import type { PricingQuoteResponse, ProductCard } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";
import { ERP_HD_CONFIG } from "./erp-detail-content";
import { ProductDetailHdPage } from "./ProductDetailHdPage";

export interface ErpProductDetailHdProps {
  locale: PepLocale;
  product: ProductCard & { complementary?: ProductCard[] };
  prices: Record<string, PricingQuoteResponse>;
  description: string;
  showDemo: boolean;
  showTrial: boolean;
}

/** ERP HD — shared ProductDetailHdPage + executive hero assets. */
export function ErpProductDetailHd(props: ErpProductDetailHdProps) {
  return <ProductDetailHdPage {...props} config={ERP_HD_CONFIG} />;
}
